export default __webpack_public_path__ + "static/media/faq_icon.a580963d.svg";